const FLIPBOOK_DOWNLOAD_EVENT = 'hei:pdfFlipbookDownload'
const FLIPBOOK_PAGE_CHANGE_EVENT = 'hei:pdfFlipbookPageChange'

const push = (event) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(event)
}

const analytics = {
    init() {
        document.addEventListener(FLIPBOOK_DOWNLOAD_EVENT, ({ detail = {} }) => {
            push({
                event: 'flipbook_download',
                flipbook_title: detail.title,
                file_type: detail.fileType,
                display_context: detail.displayContext,
            })
        })

        document.addEventListener(FLIPBOOK_PAGE_CHANGE_EVENT, ({ detail = {} }) => {
            push({
                event: 'flipbook_page_view',
                flipbook_title: detail.title,
                page_number: detail.pageNumber,
                page_end: detail.pageEnd,
                total_pages: detail.totalPages,
                navigation_method: detail.navigationMethod,
                display_context: detail.displayContext,
            })
        })
    },
}

export default analytics
